import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import confetti from 'canvas-confetti';
import useContent from '../stores/useContent';
const breakpoints = useBreakpoints(breakpointsTailwind);
const mediumDevice = breakpoints.greaterOrEqual('md');
const randomRange = (min, max) => Math.random() * (max - min) + min;

export default function getConfetti(
  el: HTMLElement,
  colours: string[],
  angle: number
) {
  if (!el) return;
  const { compiled } = storeToRefs(useContent());
  const content = compiled;
  if (content.value.course['hide-confetti']) return;
  let xPos = 0;
  let yPos = 0.2;
  const confettiAngle = angle
    ? randomRange(angle - 35, angle + 35)
    : mediumDevice.value
      ? randomRange(-45, 35)
      : randomRange(-25, -155);

  if (el) {
    xPos =
      (el.getBoundingClientRect().left + el.offsetWidth / 2) /
      window.innerWidth;
    yPos =
      (el.getBoundingClientRect().top + el.offsetHeight / 2) /
      window.innerHeight;
  }

  // blast confetti for X seconds
  const end = Date.now() + 2000;

  (function frame() {
    confetti({
      particleCount: 4,
      angle: confettiAngle,
      spread: randomRange(10, 30),
      colors: colours,
      drift: randomRange(0.1, 0.9),
      startVelocity: mediumDevice.value
        ? randomRange(10, 80)
        : randomRange(5, 40),
      origin: { x: xPos, y: yPos }
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
}
